let actionsArray = [];

export const getActionsArray = () => actionsArray;

export const getActionsMiddleware = () => next => action => {
  actionsArray.push(action);
  return next(action);
};

export const clearActionsArray = () => {
  actionsArray = [];
};
